import { prepareContent } from '../prepareContent';

export function processingShortCode({ attributes }: TContent): TContent | undefined {
  if (attributes?.content?.[0]) {
    return prepareContent([attributes?.content?.[0]], false)[0];
  }
}
